import { ModelTypeOptions } from "../../../../models/simulator/options";

export const modelPriorityList = [
	ModelTypeOptions.FIXED_FEE_DISCOUNT,
	ModelTypeOptions.FREE_OR_DISCOUNTED_INITIATION,
	ModelTypeOptions.INGREDIENT_BASED_DISCOUNT,
	ModelTypeOptions.BUDGET_CAP,
	ModelTypeOptions.PRICE_DOSE_CAP,
	ModelTypeOptions.UTILIZATION_CAP,
	ModelTypeOptions.INDICATION_BASED,
	ModelTypeOptions.OUTCOME_BASED,
];
